function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.235 1.75H4.765A3.018 3.018 0 001.75 4.765v14.471a3.018 3.018 0 003.015 3.015h14.471a3.018 3.018 0 003.015-3.015V4.765a3.02 3.02 0 00-3.016-3.015zm1.809 17.485c0 .997-.811 1.809-1.809 1.809H4.765a1.811 1.811 0 01-1.809-1.809v-2.181l4.866-5.407 6.573 5.975 3.635-3.029 3.015 2.512v2.13zm0-3.699l-3.015-2.512-3.601 3L7.737 9.94l-4.781 5.312V4.765c0-.997.811-1.809 1.809-1.809h14.471c.997 0 1.809.811 1.809 1.809v10.771z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.221 10.794c1.662 0 3.015-1.352 3.015-3.015s-1.352-3.015-3.015-3.015c-1.662 0-3.015 1.352-3.015 3.015s1.352 3.015 3.015 3.015zm0-4.823c.997 0 1.809.811 1.809 1.809s-.811 1.809-1.809 1.809-1.809-.811-1.809-1.809.811-1.809 1.809-1.809z"
});

var SvgPicture = function SvgPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 16,
    height: 16,
    fill: "#9193A9"
  }, props), _ref, _ref2);
};

export default SvgPicture;